<template>
  <div style="float: right;min-width:90px;max-width: 153.5px;width: max-content;">

    <slot
      name="botao-editar"
      :props="propriedades"
    >
      <b-btn
        v-if="permissaoUpdate"
        v-b-tooltip.hover
        title="Editar"
        variant="none"
        class="btn-outline-success btn-none rounded-pill icone-acao"
        style="margin-right:0.3rem"
        @click="editarItem(propriedades.row)"
      >
        <feather-icon icon="Edit2Icon" />
      </b-btn>
    </slot>

    <slot
      name="botao-info"
      :props="propriedades"
    >
      <b-btn
        :id="`infoBtn${propriedades.row.id}`"
        v-b-tooltip.hover
        v-b-modal="`modalinfo${propriedades.row.id}`"
        title="Informações"
        variant="none"
        :class="['btn-none rounded-pill icone-acao', {'btn-info':propriedades.row.hasUsuarioInativoVinculado, 'btn-outline-info':!propriedades.row.hasUsuarioInativoVinculado}]"
        style="margin-right:0.3rem"
        @click="mostrarInfo = true"
      >
        <feather-icon icon="InfoIcon" />
      </b-btn>
    </slot>

    <slot
      name="botao-copiar"
      :props="propriedades"
    >
      <b-btn
        v-if="mostrarCopia && permissaoCreate"
        v-b-tooltip.hover
        title="Copiar"
        variant="none"
        class="btn-outline-primary btn-none rounded-pill icone-acao"
        style="margin-right:0.3rem"
        @click="copiarItem(propriedades.row)"
      >
        <feather-icon icon="CopyIcon" />
      </b-btn>
    </slot>

    <slot
      name="botao-imprimir"
      :props="propriedades"
    >
      <b-btn
        v-if="permissaoImprimir"
        v-b-tooltip.hover
        title="Imprimir"
        variant="none"
        class="btn-outline-dark btn-none  rounded-pill icone-acao"
        style="margin-right:0.3rem"
        @click="imprimirItem(propriedades.row)"
      >
        <feather-icon icon="PrinterIcon" />
      </b-btn>
    </slot>

    <slot
      name="botao-adicional"
    />

    <slot
      name="botao-remover"
      :props="propriedades"
    >
      <b-btn
        v-if="permissaoDelete"
        v-b-tooltip.hover
        title="Remover"
        variant="none"
        class="btn-outline-danger btn-none  rounded-pill icone-acao"
        @click="removerItem([propriedades.row])"
      >
        <feather-icon icon="TrashIcon" />
      </b-btn>
    </slot>

    <div v-if="mostrarInfoModal">
      <b-modal
        v-if="mostrarInfoModal"
        :id="`modalinfo${propriedades.row.id}`"
        size="md"
        hide-footer
      >
        <template #modal-header="{ close }">
          <h5 style="margin-top:0.5rem">
            Informações adicionais
          </h5>
          <button
            size="sm"
            class="close info-close"
            @click="close()"
          >
            <feather-icon icon="XIcon" />
          </button>
        </template>

        <div v-if="info === null">
          <b-row>
            <b-col cols="12">
              Nenhuma informação disponível
            </b-col>
          </b-row>
          <span>{{ info }}</span>
        </div>
        <div v-else>
          <div
            v-for="(val,i) in info"
            :key="`info${i}`"
          >
            <b-row>
              <b-col cols="12">
                {{ `${val.label}${propriedades.row[val.campo]}` }}
              </b-col>
            </b-row>
          </div>
          <slot
            name="info-adicional"
          />
        </div>
      </b-modal>
    </div>
    <div v-else>
      <b-popover
        :id="`info${propriedades.row.id}`"
        :ref="`info${propriedades.row.id}`"
        placement="auto"
        :target="`infoBtn${propriedades.row.id}`"
        triggers="click"
        custom-class="info-adicional"
        @show="abrirInfo(propriedades.row.id)"
      >
        <div slot="title">
          <span
            class="text-center"
            style="vertical-align: sub"
          >Informações adicionais</span>
          <b-button
            variant="none"
            class="close "
            @click="fecharInfo(propriedades.row.id)"
          >
            <span aria-hidden="true">&times;</span>
          </b-button>
        </div>
        <div v-if="info === null">
          <b-row>
            <b-col cols="12">
              Nenhuma informação disponível
            </b-col>
          </b-row>
          <span>{{ info }}</span>
        </div>
        <div v-else>
          <div
            v-for="(val,i) in info"
            :key="`info${i}`"
          >
            <b-row>
              <b-col cols="12">
                {{ `${val.label}${(propriedades.row[val.campo] ? propriedades.row[val.campo] : '')}` }}
              </b-col>
            </b-row>
          </div>

          <slot
            name="corpo-info-adicional"
          />
        </div>
      </b-popover>
    </div>
  </div>
</template>

<style scoped>
.info-adicional {
  max-width: 100% !important;
}
</style>

<script>
export default {
  props: {
    propriedades: {
      type: Object,
      default: null,
    },
    info: {
      type: Array,
      default: null,
    },
    mostrarInfoModal: {
      type: Boolean,
      default: false,
    },
    mostrarCopia: {
      type: Boolean,
      default: false,
    },
    permissaoCreate: {
      type: Boolean,
      default: false,
    },
    permissaoDelete: {
      type: Boolean,
      default: false,
    },
    permissaoUpdate: {
      type: Boolean,
      default: false,
    },
    permissaoImprimir: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mostrarInfo: false,
    }
  },
  methods: {
    abrirInfo(value) {
      this.$emit('abrir-info', value)
    },
    fecharInfo(value) {
      this.$emit('fechar-info', value)
    },
    editarItem(value) {
      this.$emit('editar', value)
    },
    copiarItem(value) {
      this.$emit('copiar', value)
    },
    removerItem(value) {
      this.$emit('remover', value)
    },
    imprimirItem(value) {
      this.$emit('imprimir', value)
    },
  },
}
</script>
